import { render, staticRenderFns } from "./TopNavBg.vue?vue&type=template&id=1be8b9ef&"
import script from "./TopNavBg.vue?vue&type=script&lang=js&"
export * from "./TopNavBg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports